const EN_US_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

export function formatPublishDate(value: string | number | Date): string {
  return new Date(value).toLocaleDateString('en-US', EN_US_DATE_OPTIONS);
}

function toIsoOrNull(value: string | number | Date): string | null {
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
}

/**
 * Resolve user-facing publish date from page model override, else Builder lastUpdated.
 * - Display: lastUpdatedAt text as-is when set; otherwise formatted content.lastUpdated
 * - Schema ISO: parse lastUpdatedAt when possible; otherwise content.lastUpdated
 *
 * Page model field name matches Builder Staging: `lastUpdatedAt` (Carlos / BE-43096).
 * Builder may return a string, timestamp number, or Date depending on field type / editor state.
 */
export function resolvePublishDate(
  lastUpdatedAt?: string | number | Date | null,
  contentLastUpdated?: number | string | null
): { displayText: string | null; datePublishedIso: string | null } {
  const fallbackIso = contentLastUpdated == null || contentLastUpdated === '' ? null : toIsoOrNull(contentLastUpdated);

  if (typeof lastUpdatedAt === 'string') {
    const override = lastUpdatedAt.trim();
    if (override) {
      const parsed = Date.parse(override);
      return {
        displayText: override,
        datePublishedIso: Number.isNaN(parsed) ? fallbackIso : new Date(parsed).toISOString(),
      };
    }
  } else if (typeof lastUpdatedAt === 'number' || lastUpdatedAt instanceof Date) {
    const iso = toIsoOrNull(lastUpdatedAt);
    if (iso) {
      return {
        displayText: formatPublishDate(lastUpdatedAt),
        datePublishedIso: iso,
      };
    }
  }

  if (!fallbackIso || contentLastUpdated == null || contentLastUpdated === '') {
    return { displayText: null, datePublishedIso: null };
  }

  return {
    displayText: formatPublishDate(contentLastUpdated),
    datePublishedIso: fallbackIso,
  };
}
